
import './App.css';
import Dictionary from './Dictionary';




function App() {
  return (
    <div className="App">
      <div className="container">
       <div className="neon">
        <h2>DICTIONARY</h2>
       </div>
      
      <header className="App-header">
       
      
      </header>
        
      <main>
        
        <Dictionary defaultKeyword="Sword"/>
      </main>
      <footer className="App-footer">Coded by Ashley Brianna <a href='https://github.com/Ashleyxbrianna/dictionary-project' target="_blank" rel='noreferrer'>Open sourced</a></footer>
    </div>
    </div>  );
}

export default App;
